import Confidentiality from './Confidentiality'

export default Confidentiality
